import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';
import {
    mapWorkAssignmentCapabilities,
    type WorkAssignmentAssigneeOption,
    type WorkAssignmentCapabilities,
} from '../RawImageReview/RawImageReviewQuery.services';

const pick = (raw: Record<string, unknown>, camel: string, pascal: string) => raw[camel] ?? raw[pascal];

const GetContext = async (featureKey: string): Promise<WorkAssignmentCapabilities> => {
    const raw = (await request({
        url: ApiURL.Query.WorkAssignmentQueryURL.GetContext(featureKey),
        method: RequestType.GET,
    })) as Record<string, unknown> | null;

    return mapWorkAssignmentCapabilities(raw);
};

/** Atanabilecek kişiler. Yalnızca atama yetkisi olan kullanıcı için dolu döner. */
const GetAssignees = async (featureKey: string): Promise<WorkAssignmentAssigneeOption[]> => {
    const raw = (await request({
        url: ApiURL.Query.WorkAssignmentQueryURL.GetAssignees(featureKey),
        method: RequestType.GET,
    })) as Record<string, unknown>[] | null;

    return (Array.isArray(raw) ? raw : []).map((item) => ({
        username: String(pick(item, 'username', 'Username') ?? ''),
        displayName: String(pick(item, 'displayName', 'DisplayName') ?? ''),
    }));
};

export const WorkAssignmentQuery = {
    GetContext,
    GetAssignees,
};
